import fetch from '@/utils/fetch'
import {resourceFetch} from '@/utils/fetch'

/**
 * 统一处理请求参数
 * */
function filterURLSearchParams(args = {}) {
  const params = new URLSearchParams();
  Object.keys(args).forEach(key => {
    params.append(key, args[key])
  });
  return params
}

/**
 * 资源图谱
 * */
/**
 * 套件列表页
 * */
export function getSysAutonomicResourceList(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/getSysAutonomicResourceAtlsList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 根据ID获得图谱详细信息
 * */
export function getGradeAtlasDetailListByAtlasId(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/getGradeAtlasDetailListByAtlasId',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 根据ID获得图谱详细信息
 * */
export function getGradeLevelListByAtlasId(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/getGradeLevelListByAtlasId',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增年级资源图谱
 * */
export function addGradeAtlas(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/addGradeAtlas',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 编辑年级资源图谱
 * */
export function editGradeAtlas(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/editGradeAtlas',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 获得年级资源图谱详细信息
 * */
export function getGradeAtlasDetailInfoById(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/getGradeAtlasDetailInfoById',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 获得年级资源图谱详细信息
 * */
export function deleteGradeAtlas(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/deleteGradeAtlas',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 学科
 * */
/**
 * 查询年级下资源图谱目录树列表
 * */
export function findGradeAtlasDetailList(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/findGradeAtlasDetailList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询对应年级资源图谱下的课程列表
 * */
export function getChildAtlasDetailListByPid(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/getChildAtlasDetailListByPid',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增资源图谱详细信息
 * */
export function addAtlasDetail(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/addAtlasDetail',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 编辑资源图谱详细信息
 * */
export function editAtlasDetail(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/editAtlasDetail',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 删除资源图谱详细信息
 * */
export function deleteAtlasDetail(args) {
  return resourceFetch({
    url: 'studyResourceAtlas/deleteAtlasDetail',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}



// WEBPACK FOOTER //
// ./src/api/resourceMap.js